import { render, staticRenderFns } from "./StudyResultDetailTable.vue?vue&type=template&id=f2a100d2&scoped=true&lang=pug"
import script from "./StudyResultDetailTable.vue?vue&type=script&lang=ts"
export * from "./StudyResultDetailTable.vue?vue&type=script&lang=ts"
import style0 from "./StudyResultDetailTable.vue?vue&type=style&index=0&id=f2a100d2&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2a100d2",
  null
  
)

export default component.exports